export const UPDATE_CUSTOMER_TYPE = 'UPDATE_CUSTOMER_TYPE';

const initialState = {
  currentCustomerType: undefined,
};

const customerTypeReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_CUSTOMER_TYPE: {
      return { ...state, currentCustomerType: action.payload };
    }
    default: {
      return state;
    }
  }
};

export default customerTypeReducer;



// WEBPACK FOOTER //
// ./src/reducers/customer_type_reducer.js